import React from 'react';
import { TextField, useTheme } from '@mui/material';
import { FieldLabel } from './Styles';
import { tokens } from '../theme';

const TextFieldComp = ({ label, value, onChange, error, helperText, name, children, ...props }) => {
   const theme = useTheme();
      const colors = tokens(theme.palette.mode);
  return (
    <div>
      <TextField
        fullWidth
        label={label}
        name={name}
        value={value}
        onChange={onChange}
        error={Boolean(error)}
        helperText={helperText}
        {...props}
        sx={FieldLabel(colors)}
      />
      {children}
    </div>
  );
};

export default TextFieldComp;

